/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import ArticleOverview from "./components/ArticleOverview";

/* utilities */
import { parseDataToProps } from '~/utilities';

const articleOverviewNodes = Array.from(document.querySelectorAll('.article-overview'));
[...articleOverviewNodes].forEach((node) => render(<ArticleOverview {...parseDataToProps(node.dataset)} />, node));
